import { UPLOAD_ENTITY_TYPES } from "constants/documentUploads";

import { PROPOSAL_OUTLINE_OWNER_TYPES } from "../constants";

export const BASE_URL = "/api/proposal-outlines";
export const ERROR_TITLE = "There was a problem taking action on this outline.";

export const getOwnerUrl = (ownerType, ownerId) =>
  `${BASE_URL}/owner/${ownerType}/${ownerId}`;

const ENTITY_TYPE_BY_OWNER = {
  PROPOSAL: UPLOAD_ENTITY_TYPES.PROPOSAL,
  MISC_ANALYSIS: UPLOAD_ENTITY_TYPES.MISC_ANALYSIS,
};

const WRITING_ENTITY_TYPE_BY_OWNER = {
  PROPOSAL: UPLOAD_ENTITY_TYPES.PROPOSAL,
  MISC_ANALYSIS: UPLOAD_ENTITY_TYPES.MISC_ANALYSIS_PROPOSAL_WRITING,
};

export const uploadEntityTypeForOwner = (ownerType) =>
  ENTITY_TYPE_BY_OWNER[ownerType];

export const writingEntityTypeForOwner = (ownerType) =>
  WRITING_ENTITY_TYPE_BY_OWNER[ownerType];

const OWNER_BY_WRITING_ENTITY_TYPE = {
  [UPLOAD_ENTITY_TYPES.PROPOSAL]: PROPOSAL_OUTLINE_OWNER_TYPES.PROPOSAL,
  [UPLOAD_ENTITY_TYPES.MISC_ANALYSIS_PROPOSAL_WRITING]:
    PROPOSAL_OUTLINE_OWNER_TYPES.MISC_ANALYSIS,
};

export const outlineOwnerTypeForEntityType = (entityType) =>
  OWNER_BY_WRITING_ENTITY_TYPE[entityType];
